export default __webpack_public_path__ + "static/media/logo-mini.f27e6f9c.svg";